import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProfile } from 'actions/profile'
import { DrivingProfile } from 'types/profile'
import { submitNewVehicleData, validateDriversLicenseData, validateNewVehicleData } from 'util/vehicle'
import { Form } from 'roadie-ui'
import { createDriversLicense } from 'util/server/mainApi'

async function submitLicenseData(data: any, dispatch: any) {
  const { number, state, expiration_date: expires } = data
  const month = expires.substring(0, 2)
  const day = expires.substring(2, 4)
  const year = expires.substring(4, 8)
  const expiration_date = `${year}-${month}-${day}`
  try {
    await createDriversLicense({ number, state, expiration_date })
  } catch (error) {
    dispatch(getProfile())
    throw error
  }
}

export const useDrivingInfoRegistrationFormViewModel = () => {
  const profile = useSelector<any, DrivingProfile>((state) => state.profile)
  const driversLicense = profile.drivers_license ?? {}
  const dispatch = useDispatch()

  const handleData = useCallback(
    async (data: any) => {
      validateDriversLicenseData(dispatch, data)
      validateNewVehicleData(dispatch, data, true)
      await submitNewVehicleData(dispatch, data, true)
      await submitLicenseData(data, dispatch)
      return getProfile()(dispatch)
    },
    [dispatch]
  )

  const validations = [
    ['number', Form.validations.required],
    ['state', Form.validations.required],
    ['expiration_date', Form.validations.required],
    ['color', Form.validations.required],
    ['license_plate', Form.validations.required],
    ['license_state', Form.validations.required],
  ]

  return {
    driversLicense,
    handleData,
    validations,
  }
}
